// Display labels for stored role values. The stored value NEVER changes —
// `manager` stays `manager` in the DB; only the label reads "Recruiting Manager".
//
// Org chart (owner's rule, 5 Sep 2026):
//   recruiter → Recruiting Manager → Director → Admin (CEO)
//   BDE       → Director → Admin (CEO)
// Business Development is a Director+ line. The old `manages_bd` "BDE Manager"
// flag is retired — a Recruiting Manager never owns BD work.
export const ROLE_LABELS = {
  admin: 'Admin',
  director: 'Director',
  manager: 'Recruiting Manager',
  recruiter: 'Recruiter',
  bde: 'BDE',
};

export const roleLabel = (role) => ROLE_LABELS[role] || (role ? role.charAt(0).toUpperCase() + role.slice(1) : '');

export const userRoleLabel = (u) => roleLabel(u?.role);

// Compact variant for badges and dense table cells.
export const roleLabelShort = (u) =>
  (u?.role === 'manager' ? 'Rec. Manager' : roleLabel(u?.role));

export const hasBdAccess = (u) => ['admin', 'director', 'bde'].includes(u?.role);
